import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'CSS Grid';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "css-grid"
    }}>{`CSS Grid`}</h1>
    <p>{`Rebass components can be used to create one-off or reusable CSS Grid layout components.
While the entirety of what's possible with CSS Grid is outside the scope of this guide, the following should demonstrate how to apply any CSS Grid layout using Rebass.`}</p>
    <Note mdxType="Note">
      <p>{`This guide is a work-in-progress.
If you'd like to help make this better,
please open an issue or pull request on `}<a parentName="p" {...{
          "href": "https://github.com/rebassjs/rebass"
        }}>{`GitHub`}</a>{`.`}</p>
    </Note>
    <p>{`CSS Grid is great for arranging direct child elements without the need for additional styles applied to the children.
Create an extension of the Box component that can wrap other elements to apply a grid layout.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example grid layout component
import React from 'react'
import { Box } from 'rebass'

export default props =>
  <Box
    {...props}
    sx={{
      display: 'grid',
      gridGap: 3,     // theme.space[3]
    }}
  />
`}</code></pre>
    <p>{`By using the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop, CSS properties such as `}<inlineCode parentName="p">{`gridGap`}</inlineCode>{` will use values from your theme object.
This can help ensure consistent whitespace throughout your layout.`}</p>
    <h2 {...{
      "id": "auto-columns"
    }}>{`Auto Columns`}</h2>
    <p>{`Using the `}<inlineCode parentName="p">{`grid-auto-columns`}</inlineCode>{` property, you can quickly lay out child elements in a tile-based grid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example grid layout component
import React from 'react'
import { Box } from 'rebass'

export default props =>
  <Box
    {...props}
    sx={{
      display: 'grid',
      gridGap: 3,     // theme.space[3]
      gridTemplateColumns: 'repeat(auto-fit, minmax(128px, 1fr))',
    }}
  />
`}</code></pre>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <p>{`Use the live demo below to explore different layouts using CSS Grid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Box
  sx={{
    display: 'grid',
    gridGap: 4,
    gridTemplateColumns: 'repeat(auto-fit, minmax(128px, 1fr))',
  }}>
  <Heading p={3} bg='muted'>Hello</Heading>
  <Box p={3} color='background' bg='primary'>CSS Grid</Box>
</Box>
`}</code></pre>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <p>{`There are many resources for learning how to use CSS Grid layout.
To fully understand any API in CSS, I `}<em parentName="p">{`highly`}</em>{` recommend reading the specification, since it is the authoritative source for how CSS is intended to work:`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://www.w3.org/TR/css-grid-1/"
        }}>{`CSS Grid Layout Module Level 1`}</a></strong></p>
    <p>{`Once you have a basic grasp of the concepts in the specification, MDN is an excellent resource for learning any web technology:`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout"
        }}>{`MDN: CSS Grid Layout`}</a></strong></p>
    <p>{`Additional resources:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gridbyexample.com/"
        }}>{`Grid by Example`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://labs.jensimmons.com/"
        }}>{`Jen Simmon's Lab`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://css-tricks.com/snippets/css/complete-guide-grid/"
        }}>{`CSS Tricks`}</a></li>
    </ul>
    {
      /* vet this? */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      